import RelationshipTableFilters from '@/components/tables/RelationshipTableFilters';

const RelationshipCompaniesTableFilters = () => (
	<RelationshipTableFilters ownerLabel='Company owner' />
);

export default RelationshipCompaniesTableFilters;
